import { FIRE_DEPARTMENT_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Idaho Falls Form": {
    parameters: {
      linkUrls: ["https://www.idahofallsidaho.gov/1220/Forms-and-Applications"],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: false,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.ID.IDAHO_FALLS,
          name: "Idaho Falls Fire Dept",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "ID",
  },
  "Idaho 312 Exemption Form": {
    parameters: {
      linkUrls: ["https://ioem.idaho.gov/wp-content/uploads/2019/04/Tier-II-Exemption-Form.pdf"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "ID",
  },
};
